import React, { useState, useEffect, useRef } from 'react';
import { FaShoppingBag, FaBars, FaTimes, FaUserCircle } from 'react-icons/fa';
import { NavLink, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef();

  const { user } = useSelector((state) => state.auth);
  const { cartItems } = useSelector((state) => state.cart);

  const closeMenus = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', closeMenus);
    return () => document.removeEventListener('mousedown', closeMenus);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-white shadow text-[#1b1d3c] font-medium" ref={dropdownRef}>
      <div className="max-w-7xl mx-auto flex justify-between items-center py-4 px-4">
        {/* Logo */}
        <img
          src="/Images/logo.png"
          alt="Logo"
          className="w-30 h-20 object-contain"
        />

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          {[
            { to: '/', label: 'Home' },
            { to: '/about', label: 'About Us' },
            { to: '/job', label: 'Jobs' },
            { to: '/courses', label: 'Courses' },
            { to: '/blogs', label: 'Blog' },
            { to: '/contact', label: 'Contact' },
          ].map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive ? 'text-[#345bf3] font-bold underline' : 'hover:underline'
              }
            >
              {label}
            </NavLink>
          ))}

          <NavLink to="/cart" className="text-xl relative">
            <span className="flex items-center gap-1 text-[#345bf3]">
              <FaShoppingBag />
              {cartItems?.length ? `(${cartItems?.length})` :  ''}
            </span>
          </NavLink>

          {user ? (
            <NavLink to="/profile" className="text-2xl ml-2">
              <FaUserCircle />
            </NavLink>
          ) : (
            <NavLink
              to="/login"
              className="ml-2 px-4 py-2  text-white bg-[#fc3c04] rounded-lg text-sm font-semibold hover:bg-[#345bf3] hover:text-white"
            >
              Log In
            </NavLink>
          )}
        </nav>

        {/* Mobile Icons */}
        <div className="md:hidden flex items-center gap-4">
          <NavLink to="/cart" className="relative text-xl text-[#345bf3]">
            <FaShoppingBag />
            {cartItems?.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs px-1 rounded-full">
                {cartItems.length}
              </span>
            )}
          </NavLink>

          <button
            className="text-2xl"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? 'Close Menu' : 'Open Menu'}
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden px-6 pb-4 space-y-4">
          <Link to="/" className="block" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/about" className="block" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
          <Link to="/job" className="block" onClick={() => setMobileMenuOpen(false)}>Jobs</Link>
          <Link to="/courses" className="block" onClick={() => setMobileMenuOpen(false)}>Courses</Link>
          <Link to="/blogs" className="block" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
          <Link to="/contact" className="block" onClick={() => setMobileMenuOpen(false)}>Contact</Link>

          {user ? (
            <Link to="/profile" className="flex items-center gap-2" onClick={() => setMobileMenuOpen(false)}>
              <FaUserCircle className="text-xl" /> <span>Profile</span>
            </Link>
          ) : (
            <Link
              to="/login"
              className="block mt-2 px-4 py-2 bg-[#fc3c04] text-white rounded-lg text-sm font-semibold hover:bg-[#345bf3]"
              onClick={() => setMobileMenuOpen(false)}
            >
              Log In
            </Link>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
